import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useCustomContent } from '../../hooks/customContent';

const PricingDialog = ({ open, onClose }) => {
  const { t } = useTranslation(['common']);
  const pricingContent = useCustomContent('pricing');

  const handleClose = () => {
    if (typeof onClose === 'function') {
      onClose();
    }
  };

  if (!pricingContent) {
    return null;
  }

  const content = () => {
    try {
      return decodeURIComponent(pricingContent.content);
    } catch (e) {
      return;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      aria-labelledby="pricing-dialog-title"
    >
      <DialogTitle id="pricing-dialog-title">
        {pricingContent.title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <span
            dangerouslySetInnerHTML={{
              __html: content()
            }}
          ></span>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {t('common:close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PricingDialog;
